import { post } from "../axios";
import { responseIsSuccessful } from "../global-helpers";
import { ApiResponseStatus } from "../constants/enums";

export async function login(email, password) {
  return await post("login", { email, password }, null)
    .then(res => {
      if (responseIsSuccessful(res)) {
        if (res.data.access_token) {
          window.localStorage.apiToken = res.data.access_token;
        }

        if (res.data.user) {
          if (res.data.user.name) {
            window.localStorage.userName = window.btoa(res.data.user.name);
          }
          if (res.data.user.type) {
            window.localStorage.userType = window.btoa(res.data.user.type);
          }
          if (res.data.user.email) {
            window.localStorage.userEmail = window.btoa(res.data.user.email);
          }
        }

        return ApiResponseStatus.SUCCESS;
      }
      return ApiResponseStatus.ERROR;
    })
    .catch(err => {
      console.log(err);
      return ApiResponseStatus.ERROR;
    });
}

export async function forgotPassword(email) {
  return await post("forgot-password", { email }, null)
    .then(res => {
      let statusAndMessage = { status: ApiResponseStatus.ERROR, message: null };
      if (responseIsSuccessful(res)) {
        statusAndMessage.status = ApiResponseStatus.SUCCESS;
        statusAndMessage.message =
          "A password reset email has been sent to the address you provided.";
      }
      return statusAndMessage;
    })
    .catch(err => {
      console.log(err);
      let statusAndMessage = { status: ApiResponseStatus.ERROR, message: null };

      if (err.response.status === 404) {
        statusAndMessage.message =
          "No user found for the provided email address.";
      } else {
        statusAndMessage.message = "An error occurred. Please try again.";
      }

      return statusAndMessage;
    });
}

export async function verifyResetPassword(data) {
  return await post(
    "verify-reset-password",
    { hash: data.hash, email: data.email },
    null
  )
    .then(res => {
      let statusAndMessage = {
        status: ApiResponseStatus.ERROR,
        message: null,
        token: null
      };
      if (responseIsSuccessful(res)) {
        statusAndMessage.status = ApiResponseStatus.SUCCESS;
        if (res.data.access_token) {
          statusAndMessage.token = res.data.access_token;
        }
      }
      return statusAndMessage;
    })
    .catch(err => {
      console.log(err);
      let statusAndMessage = {
        status: ApiResponseStatus.ERROR,
        message: null,
        token: null
      };
      if (err.response.status === 404) {
        statusAndMessage.message =
          err.response.data.error === "User not found."
            ? err.response.data.error
            : "Your password reset code cannot be found or is expired.";
      } else {
        statusAndMessage.message = "An error occurred. Please try again.";
      }

      return statusAndMessage;
    });
}

export async function resetPassword(data) {
  return await post(
    "reset-password",
    {
      new_password: data.newPassword,
      again_password: data.repeatPassword,
      access_token: data.accessToken
    },
    null
  )
    .then(res => {
      let statusAndMessage = { status: ApiResponseStatus.ERROR, message: null };
      if (responseIsSuccessful(res)) {
        statusAndMessage.status = ApiResponseStatus.SUCCESS;
        statusAndMessage.message = "Your password was reset successfully.";
      }
      return statusAndMessage;
    })
    .catch(err => {
      let statusAndMessage = { status: ApiResponseStatus.ERROR, message: null };
      if (err.response.status === 404) {
        statusAndMessage.message =
          err.response.data.error === "User not found."
            ? err.response.data.error
            : "Your password reset access token is invalid.";
      } else if (
        err.response.status === 400 &&
        err.response.data.error === "Passwords do not match."
      ) {
        statusAndMessage.message = err.response.data.error;
      } else {
        statusAndMessage.message = "An error occurred. Please try again.";
      }

      return statusAndMessage;
    });
}
